import { render, staticRenderFns } from "./GradeDescription.vue?vue&type=template&id=72f8bbb7&"
import script from "./GradeDescription.vue?vue&type=script&lang=js&"
export * from "./GradeDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports